import { useTranslation } from 'react-i18next';

import WarningModal, { type WarningModalProps } from '~molecules/WarningModal';

type ColorChangeModalProps = Pick<
  WarningModalProps,
  'onCancel' | 'onConfirm' | 'isVisible'
> & { colorName: string | undefined };

const ColorChangeModal = ({
  isVisible,
  colorName,
  onCancel,
  onConfirm,
}: ColorChangeModalProps) => {
  const { t } = useTranslation();

  const modalTitle = `${t(
    'SCROLLABLE_AREA.COLOR.CONFIRMATION_MODAL.TITLE'
  )} ${colorName ?? ''}?`;
  const modalDescription = t(
    'SCROLLABLE_AREA.COLOR.CONFIRMATION_MODAL.DESCRIPTION'
  );
  const buttons = {
    cancel: t('SCROLLABLE_AREA.COLOR.CONFIRMATION_MODAL.BUTTON_CANCEL'),
    confirm: t('SCROLLABLE_AREA.COLOR.CONFIRMATION_MODAL.BUTTON_CONFIRM'),
  };

  return (
    <WarningModal
      title={modalTitle}
      description={modalDescription}
      buttons={buttons}
      isVisible={isVisible}
      onCancel={onCancel}
      onConfirm={onConfirm}
    />
  );
};

export default ColorChangeModal;
